module.exports = __webpack_public_path__ + "img/building_img.5dc3fc12.png";